import { createContext } from "react";
import { Claims, Tenant, UserTypes } from "../../models";

export interface IPermissionsContext {
    authorizedTenants: Tenant[];
    userPermissions: string[];
    userRoles: UserTypes[];
    hasRole: (role: UserTypes) => boolean;
    hasAnyRole: (roles: UserTypes[]) => boolean;
    hasPermission: (permission: Claims) => boolean;
    hasAnyPermission: (permissions: Claims[]) => boolean;
    isGuest: boolean;
    isSurgeryUser: boolean;
    isGlobalAdmin: boolean;
    hasSuperAdminAccess: boolean;
}

const defaultValue: IPermissionsContext = {
    authorizedTenants: [],
    userPermissions: [],
    userRoles: [],
    hasRole: () => false,
    hasAnyRole: () => false,
    hasPermission: () => false,
    hasAnyPermission: () => false,
    isGuest: false,
    isSurgeryUser: false,
    isGlobalAdmin: false,
    hasSuperAdminAccess: false,
};

export const PermissionsContext = createContext<IPermissionsContext>(defaultValue);
PermissionsContext.displayName = "Permissions";
